/*!
 * (C) Phonero UX - ISC License
 */
import { s as setMode } from './index-9ab1fbc1.js';
import { s as setupPlatforms, i as isPlatform } from './platform-1c3ea0be.js';

const appGlobalScript = () => {
  // const doc = document;
  const win = window;
  //const Pux = ((win as any).Pux = (win as any).Pux || {});
  setupPlatforms(win);
  setMode((_elm) => {
    //return (elm as any).mode || elm.getAttribute("mode") || "ios";
    return isPlatform("ios") ? "ios" : "md";
  });
};

const globalScripts = appGlobalScript;

export { globalScripts as g };
